<template>
  <div v-show="!loading">
    <page-header></page-header>

    <div class="container page-content">
      <page-steps :steps="pageSteps"></page-steps>

      <form class="form-horizontal">
        <div class="row">
          <div class="col-md-8 _margin-top-20">
            <customer-details :$v="$v.form.customer" v-show="showStep('details')"></customer-details>
            <customer-address :$form="$v.form" v-show="showStep('address')"></customer-address>
            <supplier-terms :$form="$v.form" :$v="$v.form.terms" v-show="showStep('terms')"></supplier-terms>
            <payment-details :$form="$v.form" :$v="$v.form.payment" v-show="showStep('payment')"></payment-details>
            <confirm :$form="$v.form" v-show="showStep('confirm')"></confirm>

            <uiv-alert type="danger" v-if="error.name == 'customer'">
              <b>Error</b> <br />
              Customer details could not be saved.
            </uiv-alert>

            <uiv-alert type="danger" v-if="error.name == 'address'">
              <b>Error</b> <br />
              Address details could not be saved.
            </uiv-alert>

            <uiv-alert type="danger" v-if="error.name == 'terms'">
              <b>Error</b> <br />
              Supplier terms could not be saved.
            </uiv-alert>

            <uiv-alert type="danger" v-if="error.name == 'verify bank'">
              <b>Error</b> <br />
              We could not verify your bank details.
            </uiv-alert>

            <uiv-alert type="danger" v-if="error.name == 'bank'">
              <b>Error</b> <br />
              Bank details could not be saved.
            </uiv-alert>

            <uiv-alert type="danger" v-if="error.name == 'switch'">
              <b>Error</b> <br />
              Switch could not be completed. Please contact the administrator.
            </uiv-alert>

            <div class="text-right" v-if="$v.form.$invalid == false">
              <uiv-btn type="primary" @click="onSubmit" :disabled="loading">
                <loader :show="loading"></loader> Complete Switch
              </uiv-btn>
            </div>
          </div>

          <div class="col-md-4 _margin-top-20">
            <switch-plan class="hidden-xs hidden-sm" :plan="switchPlan"></switch-plan>

            <div class="row" v-if="notDirectDebit == false && !appSettings.whiteLabel">
              <div class="col-md-12 _margin-bottom-20 _margin-top-20">
                <div class="notice">
                  <p>
                    Your Direct Debit Instruction will be confirmed to you
                    within 3 working days either by email or post.
                  </p>
                  <p>
                    The company name that will appear on your bank statement is
                    {{ switchPlan.supplierName }}.
                  </p>
                </div>
              </div>

              <div class="col-md-12 _margin-bottom-20">
                <div class="notice">
                  <h6 class="_margin-top-20">Direct Debit Guarantee</h6>
                  <ul class="bullet-points _margin-bottom-30">
                    <li>
                      This Guarantee is offered by all banks and building
                      societies that accept instructions to pay Direct Debits.
                    </li>
                    <li>
                      If there are any changes to the amount, date or frequency
                      of your Direct Debit {{ switchPlan.supplierName }} will
                      notify you 10 working days in advance of your account
                      being debited or as otherwise agreed. If you request
                      {{ switchPlan.supplierName }} to collect a payment,
                      confirmation of the amount and date will be given to you
                      at the time of the request.
                    </li>

                    <li>
                      If an error is made in the payment of your Direct Debit,
                      by {{ switchPlan.supplierName }} or your bank or building
                      society, you are entitled to a full and immediate refund
                      of the amount paid from your bank or building society
                      <br />- If you receive a refund you are not entitled to,
                      you must pay it back when
                      {{ switchPlan.supplierName }} asks you to.
                    </li>
                    <li>
                      You can cancel a Direct Debit at any time by simply
                      contacting your bank or building society. Written
                      confirmation may be required. Please also notify
                      {{ switchPlan.supplierName }}.
                    </li>
                  </ul>

                  <h6 class="_margin-top-20">
                    Instructions to your Bank/Building Society
                  </h6>
                  <ul class="bullet-points">
                    <li>
                      This Guarantee is offered by all banks and building
                      societies that accept instructions to pay Direct Debits.
                    </li>
                    <li>
                      Please pay {{ switchPlan.supplierName }} Direct Debits
                      from the account detailed in this Instruction subject to
                      the safeguards assured by the Direct Debit Guarantee. I
                      understand that this Instruction may remain with
                      {{ switchPlan.supplierName }} and, if so, details will be
                      passed electronically to my bank/building society.
                    </li>

                    <li>Date: {{ today | date }}</li>
                    <li>
                      You can cancel a Direct Debit at any time by simply
                      contacting your bank or building society. Written
                      confirmation may be required. Please also notify
                      {{ switchPlan.supplierName }}.
                    </li>
                  </ul>

                  <img class="icon" src="../../assets/direct-debit.png" />
                </div>
              </div>

              <div class="col-md-12">
                <div class="notice">
                  <h6 class="_margin-top-20">Switching is secure and easy</h6>
                  <ul class="bullet-points">
                    <li>Switching is a free service</li>
                    <li>
                      Switching is secure: your information is encrypted and
                      only used for switching supplier
                    </li>

                    <li>
                      No disruptions at any point to your energy supply during
                      the switch
                    </li>
                  </ul>

                  <div class="text-right">
                    <img class="_margin-bottom-10" src="../../assets/ofgem-confidence-code.png" />
                  </div>
                </div>
              </div>

              <div class="col-md-12 _margin-bottom-20">
                <div class="notice">
                  <h6 class="_margin-top-20">How do we use your data?</h6>
                  <p>
                    We take your privacy very seriously, and want you to
                    understand how we use your data. From this point forward
                    your data will be processed by MyUtilityGenius Ltd and
                    ultimately transferred securely to
                    {{ switchPlan.supplierName }}, the energy supplier that you
                    have chosen to switch to. Your data will be used for this
                    exclusively unless you authorise any other uses. No other
                    parties will have access to your data.
                  </p>

                  <p>
                    For more in depth information please read our
                    <a :href="appSettings.supplierPrivacyPolicy" target="_blank">privacy policy</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SwitchPlan from "@/components/switch-plan/SwitchPlan";
import CustomerDetails from "@/components/personal-details/CustomerDetails";
import CustomerAddress from "@/components/personal-details/CustomerAddress";
import SupplierTerms from "@/components/personal-details/SupplierTerms";
import PaymentDetails from "@/components/personal-details/PaymentDetails";
import Confirm from "@/components/personal-details/Confirm";

import ProgressBar from "@/components/progress/ProgressBar";
import ProgressSidebar from "@/components/progress/ProgressSidebar";
import ProgressGroup from "@/components/progress/ProgressGroup";
import ProgressGroupItems from "@/components/progress/ProgressGroupItems";
import ProgressGroupItem from "@/components/progress/ProgressGroupItem";

import PageHeader from "@/components/page-header/PageHeader";
import PageSteps from "@/components/page-steps/PageSteps";

import { mapState, mapGetters } from "vuex";

import {
  required,
  helpers,
  requiredIf,
  maxLength,
  minLength,
  numeric,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  name: "PersonalDetails",
  data() {
    return {
      pageSteps: [
        { name: "Your Current Energy Information" },
        { name: "Choose Your New Deal" },
        { name: "Sign Up", active: true },
        { name: "Switch Complete" },
      ],
      form: {
        customer: {},
        address: {
          residentialAddresses: {
            present: {},
          },
        },
        terms: {},
        payment: {},
      },
      today: new Date(),
      error: {},
    };
  },
  async mounted() {
    this.$store.commit("personal_details_customer/resetState");
    this.$store.commit("personal_details_address/resetState");
    this.$store.commit("personal_details_terms/resetState");
    this.$store.commit("personal_details_payment/resetState");

    this.$store.dispatch("page_loader/start", 0);

    await this.$store.dispatch("lookups/getEmploymentStatusList");
    await this.$store.dispatch("lookups/getTitleList");

    this.$store.dispatch("lookups/getResidentialStatusList");
    this.$store.dispatch("lookups/getDirectDebitDaysList");

    await this.$store.dispatch("personal_details_switch_plan/get");
    await this.$store.dispatch("personal_details_address/getCustomerAddress");

    this.$store.dispatch("page_loader/stop");

    this.form = {
      customer: this.customer,
      address: this.address,
      terms: this.terms,
      payment: this.payment,
    };

    this.customer.employmentStatusId = this.employmentStatusList[0].id;
    this.address.residentialAddresses.present.lengthOfResidencyInMonths = 36;
    this.address.residentialAddresses.present.residentialStatusId =
      this.residentialStatusList[0].id;

    this.terms.gasSmartMeterInstalled = this.quote.gasSmartMeterInstalled;
    this.terms.electricitySmartMeterInstalled =
      this.quote.electricitySmartMeterInstalled;
    this.terms.neitherSmartMeterInstalled =
      !this.terms.gasSmartMeterInstalled &&
      !this.terms.electricitySmartMeterInstalled;
    if (
      this.terms.electricitySmartMeterInstalled ||
      this.terms.gasSmartMeterInstalled
    ) {
      this.terms.agreeSmartMeterConditions = true;
    }
  },
  validations() {
    return {
      form: {
        customer: {
          titleId: { required },
          firstName: { required },
          lastName: { required },
          dateOfBirth: {
            required,
            over18(value) {
              if (value) {
                const split = value.split("-");
                const [year, month, day] = split.map((d) => Number(d));

                return new Date(year + 18, month - 1, day) <= new Date();
              }

              return true;
            },
          },
          emailAddress: {
            required,
            regex: helpers.regex(
              "email",
              /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
            ),
          },
          dayTimePhone: {
            required,
            numeric,
            maxLength: maxLength(11),
            minLength: minLength(10),
            regex: helpers.regex("phone", /^(?=.*\d)(?=.*[1-9]).{1,11}$/),
          },
          employmentStatusId: { required },
        },
        address: {
          previousAddresses: {
            atLeast3Years(value) {
              const { lengthOfResidencyInMonths } =
                this.address.residentialAddresses.present;

              const totalMonths = this.address.previousAddresses.reduce(
                (acc, item) => {
                  const months = item.lengthOfResidencyInMonths || 0;
                  return acc + months;
                },
                0
              );

              return totalMonths + (lengthOfResidencyInMonths || 0) >= 36;
            },
            $each: {
              lengthOfResidencyInMonths: { required, numeric },
              line1: { requiredIf: requiredIf((form) => form.manually) },
              line2: { requiredIf: requiredIf((form) => form.manually) },
              city: { requiredIf: requiredIf((form) => form.manually) },
              postcode: {
                required,
                maxLength: maxLength(7),
                regex: helpers.regex(
                  "postcode",
                  /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/
                ),
              },
            },
          },
          residentialAddresses: {
            present: {
              residentialStatusId: { required },
              lengthOfResidencyInMonths: {
                required,
                numeric,
                maxYears(value) {
                  const { lengthOfResidencyInMonths } =
                    this.address.residentialAddresses.present;

                  const totalMonths = this.address.previousAddresses.reduce(
                    (acc, item) => {
                      const months = item.lengthOfResidencyInMonths || 0;
                      return acc + months;
                    },
                    0
                  );

                  return totalMonths + (lengthOfResidencyInMonths || 0) <= 1200;
                },
              },
            },
          },
          businessAddress: {
            line1: {
              requiredIf: requiredIf(
                () => this.address.businessAddress.separateBilling
              ),
            },
            line2: {
              requiredIf: requiredIf(
                () => this.address.businessAddress.separateBilling
              ),
            },
            city: {
              requiredIf: requiredIf(
                () => this.address.businessAddress.separateBilling
              ),
            },
            postcode: {
              maxLength: maxLength(7),
              requiredIf: requiredIf(
                () => this.address.businessAddress.separateBilling
              ),
              regex: helpers.regex(
                "postcode",
                /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/
              ),
            },
          },
        },
        terms: {
          mpanNumber: {
            requiredIf: requiredIf(() => this.quote.switchType != "gasToGas"),
            maxLength: maxLength(22),
            minLength: minLength(21),
            domesticMeter(meter, form) {
              if (
                meter &&
                (meter.length == 21 || meter.length == 22) &&
                this.quote.switchType != "gasToGas"
              ) {
                const mpan = meter + "";
                const meterIdentifier = mpan.substring(0, 2);
                const domesticMeters = ["01", "02"];

                return domesticMeters.indexOf(meterIdentifier) > -1;
              }

              return true;
            },
            economy7Meter(meter, form) {
              if (
                meter &&
                this.quote.switchType != "gasToGas" &&
                this.switchPlan.isEconomy7
              ) {
                const mpan = meter + "";
                const meterIdentifier = mpan.substring(0, 2);
                const economy7Meters = ["02"];
                return economy7Meters.indexOf(meterIdentifier) > -1;
              }

              return true;
            },
            checked() {
              if (this.quote.switchType != "gasToGas") {
                return this.terms.mpanValid == true;
              }

              return true;
            },
          },
          mpanValid: {
            requiredIf: requiredIf(
              (value) => this.quote.switchType != "gasToGas"
            ),
          },
          mprnNumber: {
            requiredIf: requiredIf(
              () => this.quote.switchType != "electricityToElectricity"
            ),
            regex: helpers.regex("numberString", /^[0-9]+$/),
            maxLength: maxLength(10),
            minLength: minLength(6),
          },
          neitherSmartMeterInstalled: {
            requiredIf: requiredIf(() => {
              const { electricitySmartMeterInstalled, gasSmartMeterInstalled } =
                this.terms;

              if (
                this.quote.switchType == "gasToGas" ||
                this.quote.switchType == "electricityToElectricity"
              ) {
                return false;
              }

              return !electricitySmartMeterInstalled && !gasSmartMeterInstalled;
            }),
          },
          agreeSmartMeterConditions: {
            requiredIf: requiredIf(() => {
              const { electricitySmartMeterInstalled, gasSmartMeterInstalled } =
                this.terms;

              return electricitySmartMeterInstalled || gasSmartMeterInstalled;
            }),
          },
          specialNeedsId: {
            requiredIf: requiredIf(
              () => this.terms.hasMedicalConditionOrIndividualRequirement
            ),
          },
          suppliersTermsAndConditionsAreAccepted: {
            requiredIf: requiredIf(
              (form) => !form.suppliersTermsAndConditionsAreAccepted
            ),
          },
          happyToReceiveCreditCheck: {
            requiredIf: requiredIf((form) => {
              const validateSupplier = [8, 49];

              if (validateSupplier.indexOf(this.switchPlan.supplierId) > -1) {
                return !form.happyToReceiveCreditCheck;
              }

              return false;
            }),
          },
          happyToHaveDebtInformationAccessed: {
            requiredIf: requiredIf((form) => {
              if (this.switchPlan.supplierId == 22) {
                return !form.happyToHaveDebtInformationAccessed;
              }

              return false;
            }),
          },
          prePaymentMeterId: {
            requiredIf: requiredIf((form) => {
              if (this.switchPlan.payMethod == "PrePaymentMeter") {
                return !form.prePaymentMeterId;
              }

              return false;
            }),
          },
          switchAfterCoolingOfPeriod: {
            requiredIf: requiredIf((form) => {
              if (this.switchPlan.supplierId != 42) {
                return this.terms.switchAfterCoolingOfPeriod == null;
              }

              return false;
            }),
          },
        },
        payment: {
          accountName: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
          },
          sortCode: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
            maxLength: maxLength(6),
            minLength: minLength(6),
          },
          sortCode1: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
            numeric,
            maxLength: maxLength(2),
          },
          sortCode2: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
            numeric,
            maxLength: maxLength(2),
          },
          sortCode3: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
            numeric,
            maxLength: maxLength(2),
          },
          accountNumber: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
            numeric,
            maxLength: maxLength(8),
            minLength: minLength(6),
          },
          preferredDirectDebitDay: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
          },
          isAuthorisedToSetupDirectDebits: {
            requiredIf: requiredIf(() => {
              const { payMethod } = this.switchPlan;
              return (
                payMethod == "MonthlyDirectDebit" ||
                payMethod == "QuaterlyDirectDebit"
              );
            }),
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      notDirectDebit: "personal_details_switch_plan/notDirectDebit",
    }),
    ...mapState({
      appSettings: ({ app_settings }) => app_settings,
      quote: ({ storage }) => storage.quote,
      loading: ({ page_loader }) => page_loader.show,
      steps: ({ personal_details_questions }) =>
        personal_details_questions.steps,
      customer: ({ personal_details_customer }) => personal_details_customer,
      address: ({ personal_details_address }) => personal_details_address,
      terms: ({ personal_details_terms }) => personal_details_terms,
      payment: ({ personal_details_payment }) => personal_details_payment,
      titleList: ({ lookups }) => lookups.titles,
      employmentStatusList: ({ lookups }) => lookups.employmentStatuses,
      residentialStatusList: ({ lookups }) => lookups.residentialStatuses,
      switchPlan: ({ personal_details_switch_plan }) =>
        personal_details_switch_plan,
    }),
  },
  methods: {
    showStep(step) {
      const form = this.$v.form;
      console.log("form", form);
      
      let meterValid =
        !form.terms.mpanNumber.$invalid && !form.terms.mprnNumber.$invalid;

      if (this.quote.switchType != "gasToGas") {
        meterValid = !form.terms.mpanNumber.$invalid;
      }

      if (this.quote.switchType != "electricityToElectricity") {
        meterValid = !form.terms.mprnNumber.$invalid;
      }

      const conditions = {
        details: true,
        address: !form.customer.$invalid,
        terms: !form.customer.$invalid && !form.address.$invalid && meterValid,
        payment:
          !form.customer.$invalid &&
          !form.address.$invalid &&
          meterValid &&
          !form.terms.$invalid,
        confirm:
          !form.customer.$invalid &&
          !form.address.$invalid &&
          meterValid &&
          !form.terms.$invalid &&
          !form.payment.$invalid,
      };

      if (this.notDirectDebit) {
        conditions.payment = false;
      }

      return conditions[step];
    },
    async onSubmit() {
      const { payMethod } = this.switchPlan;
      this.error = {};
      this.$v.form.$touch();

      if (this.$v.form.$invalid) return;

      this.$store.dispatch("page_loader/start", 0);
      this.$store.dispatch("tracing/addAction", {
        name: "Action",
        value: "Complete & Switch",
      });

      try {
        await this.$store.dispatch("personal_details_customer/update");
        await this.$store.dispatch("personal_details_address/update");
        await this.$store.dispatch("personal_details_terms/update");

        if (
          payMethod == "MonthlyDirectDebit" ||
          payMethod == "QuaterlyDirectDebit"
        ) {
          await this.$store.dispatch(
            "personal_details_payment/verifyBankDetails"
          );
          await this.$store.dispatch("personal_details_payment/update");
        }

        await this.$store.dispatch(
          "personal_details_switch_plan/completeSwitch"
        );
        await this.$store.dispatch("tracing/saveActions");
      } catch (error) {
        this.$store.dispatch("tracing/addAction", {
          name: "Page",
          value: "Confirmation & Switch",
        });
        this.$store.dispatch("tracing/addAction", {
          name: "Error Page",
          value: error.status,
        });
        await this.$store.dispatch("tracing/saveActions");

        this.error.name = error;
      } finally {
        this.$store.dispatch("page_loader/stop");
      }
    },
  },
  components: {
    SwitchPlan,
    CustomerDetails,
    CustomerAddress,
    SupplierTerms,
    PaymentDetails,
    Confirm,

    ProgressBar,
    ProgressSidebar,
    ProgressGroup,
    ProgressGroupItems,
    ProgressGroupItem,
    PageHeader,
    PageSteps,
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  min-height: 1000px;
}

.card {
  width: 100%;
  padding: 15px 24px 24px 24px;
  background-color: #fdfdfd;
  display: inline-block;
  margin-bottom: 20px;
  border-top: 5px solid $brand-colour-primary;

  h6 {
    font-size: 11px;
    color: $font-paragraph-colour;
  }
}

.notice {
  position: relative;
  background-color: #f9f9f9;
  padding: 10px 20px;

  >p {
    font-size: 14px;
    line-height: 1.6;
  }

  .icon {
    position: absolute;
    top: 24px;
    right: 24px;
  }
}
</style>
